import { defineStore } from "pinia";
import { OrganizationService } from "@/api/services";

export default defineStore("organizationStore", {
  id: "organization",
  state: () => ({
    organizationList: [],
  }),
  actions: {
    /**
     * Fetch the list of organizations
     */
    async fetchOrganizationList() {
      const { organizationList } = await OrganizationService.readAll();
      this.organizationList = organizationList;
    },
    /**
     * Fetch organizations by user
     */
    async fetchOrganizationsByUser() {
      const { organizations } = await OrganizationService.readByUser();
      return organizations;
    },
    /**
     * Fetch the scopes of an organization
     * @param {Number} id
     */
    async fetchOrganizationScopes(id) {
      const { scopes } = await OrganizationService.readAllScopes(id);
      return scopes;
    },

    /**
     * Fetch the scopes of an organization
     * @param {String} slug
     */
    async fetchOrganizationMap(slug) {
      const { map } = await OrganizationService.readMap(slug);
      return map;
    },
    /**
     * Add a new organization
     * @param {Object} payload
     */
    async addOrganization(payload) {
      const {
        organization: { id },
      } = await OrganizationService.create(payload);
      const { organization } = await OrganizationService.read(id);
      this.organizationList.push(organization);
    },
    /**
     * Update an organization
     * @param {Number} id
     * @param {Object} payload
     */
    async updateOrganization(id, payload) {
      const { organization } = await OrganizationService.update(id, payload);
      await this.fetchOrganizationList();
    },
    /**
     * Delete an organization
     * @param {Number} id
     */
    async deleteOrganization(id) {
      await OrganizationService.delete(id);
      this.organizationList = this.organizationList.filter(
        (elm) => elm.id !== id,
      );
    },
    /**
     * Get all scopes for an organization
     * @param {Number} id
     */
    async getScopesForOrganization(id) {
      const scopes = await this.readAllScopes(id);
      return scopes;
    },
  },
  getters: {
    /**
     * Get the list of organizations as options
     */
    getOrganizationsAsOptions: (state) =>
      state.organizationList.map((organization) => ({
        label: organization.slug,
        value: organization.id,
      })
    ) || [],
  },
});
